import { defineStore } from 'pinia'
import { API_BASE_URL } from '../config'
import { ref, watch, shallowRef } from 'vue'
import axios from 'axios';

export function createDataStore(config) {

    return defineStore(`dataStore-${config.name}`, () => {

        const pideventcounts = ref([]);
        const pidevents = ref([])
        const pidnewjourneyevents = ref({})
        const pidjourneyevents = ref({})
        const pidjourneyeventcounts = ref({})
        const selectedeventcounts = ref([])
        const timeFilters = ref({}) // Keyed by GUID: { start: ts, end: ts, min: ts, max: ts, enabled: bool }

        const selectedRow = ref(-1);

        const eventColours = ref({
            "route": '#0000ff',
            "stops": '#00ffff',

            "newjourney": '#007d32',
            "clearjourney": '#582c4dff',
            "journeyStart": '#db0ecaff',
            "announce": '#830057',
            "onroute": '#0f750fff',
            "offroute": '#e20e19ff',
            "departedStop": '#183d26ff',
            "Doors": '#17ef10ff',
            "pos": '#ef7b10',
            "nextStop": '#e49b13ff',
            "atStop": '#e1a7bc',
            "atTerminus": '#e1a7bc',
            "approachingStop": '#22cc90',
            "approachingTerminus": '#22cc90',
            "leftStop": '#b26300',
            "tracking": '#b26300',
            "trackingSuppress": '#ec0909ff'
        })

        const isLoading = ref(false);
        const isEventsLoading = ref(false);

        async function fetchPidEventsDayCounts(options = {}) {
            isLoading.value = true;
            try {
                console.time('fetchPidEventsDayCounts');
                const token = localStorage.getItem('jwtToken');

                let filter = {
                    dbname: config.dbname,
                    ...options // Pass uid, startDate, endDate
                }

                const response = await axios.post(`${API_BASE_URL}/piddaycount`, filter, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });

                pideventcounts.value = response.data;
                console.timeEnd('fetchPidEventsDayCounts');
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            } finally {
                isLoading.value = false;
            }
        }

        function sortEventList(evtlist) {
            evtlist.sort((a, b) => {
                return a.time - b.time || (a.evtidx ?? Number.MAX_SAFE_INTEGER) - (b.evtidx ?? Number.MAX_SAFE_INTEGER);
            });
            return evtlist;
        }
        function linkJourneys(eventsdata, journeyevents, newjourneyevents) {
            let tmpguid = 1;
            let jguid = "UNSET"

            for (let event of eventsdata) {
                if (event.event === "newjourney") {
                    if (!event.guid) {
                        console.log("Missing journey guid on newjourney, createing dummy")
                        event.guid = "TMPGUID_" + tmpguid;
                        tmpguid++;
                    }

                    jguid = event.guid

                    if (newjourneyevents[jguid]) {
                        console.log("Repeated newjourney event")
                    } else {
                        newjourneyevents[jguid] = event
                        journeyevents[jguid] = []
                    }
                    journeyevents[jguid].push(event)

                } else {
                    event.guid = event.guid || jguid;
                    if (event.guid.toUpperCase() === "UNSET" || event.guid.length === 0) {
                        event.guid = jguid;
                    }

                    if (event.guid) {
                        if (journeyevents[event.guid]) {
                            journeyevents[event.guid].push(event)
                        } else {
                            console.log(`Missing journey event list for [${event.guid}]`)
                            if (journeyevents[jguid]) {
                                journeyevents[jguid].push(event)
                            }
                        }
                    } else {
                        console.log(`Missing journey event guid for event ${JSON.stringify(event)}`)
                    }
                }

            }

            return eventsdata
        }

        async function fetchPidEvents(uid, timestart, timeend) {
            isEventsLoading.value = true;
            try {
                const token = localStorage.getItem('jwtToken');

                let filter = {
                    dbname: config.dbname,
                    uid: uid,
                    timestart: timestart,
                    timeend: timeend
                }

                const response = await axios.post(`${API_BASE_URL}/pidevents`, filter, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });

                sortEventList(response.data)

                let newjourneyevents = {}
                let journeyevents = {}
                let eventsdata = linkJourneys(response.data, journeyevents, newjourneyevents)

                const eventcounts = {}
                const journeyeventcounts = {}

                for (let evt of eventsdata) {

                    let jnycounts = journeyeventcounts[evt.guid]
                    if (!jnycounts) {
                        jnycounts = {}
                        journeyeventcounts[evt.guid] = jnycounts;
                    }

                    if (!jnycounts[evt.event]) {
                        jnycounts[evt.event] = 1
                    } else {
                        jnycounts[evt.event]++;
                    }

                    if (!eventcounts[evt.event]) {
                        eventcounts[evt.event] = 1
                    } else {
                        eventcounts[evt.event]++;
                    }

                }

                let evtarray = []
                for (const event in eventcounts) {
                    evtarray.push({ event: event, count: eventcounts[event] })
                }

                // set the reactive data
                pidnewjourneyevents.value = newjourneyevents;
                pidjourneyevents.value = journeyevents;
                pidjourneyeventcounts.value = journeyeventcounts
                pidevents.value = eventsdata;
                selectedeventcounts.value = evtarray;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            } finally {
                isEventsLoading.value = false;
            }
        }

        watch(
            selectedRow,
            (newIndex, oldIndex) => {
                console.log(`selectedRow changed from ${oldIndex} to ${newIndex} now ${selectedRow.value}`);
                const sel = pideventcounts.value[selectedRow.value];
                console.log(`selected data ${JSON.stringify(sel)}`);
                const date = new Date(sel.date);
                const date2 = new Date(date.setHours(0, 0, 0, 0));
                const timestart = Math.floor(date2.getTime() / 1000);
                const timeend = timestart + (60 * 60 * 24);

                console.log(`Fetch events for ${sel.uid} from ${timestart} to ${timeend}`);

                fetchPidEvents(sel.uid, timestart, timeend);

            }
        );


        // Map ----------------
        const map = shallowRef(null);
        const activeLayers = []; // Track all layers added to map

        function setMap(mapInstance) {
            console.log("Set Map")
            map.value = mapInstance;
        }

        function addLayer(layer) {
            console.log("addLayer - IN")
            if (map.value) {
                layer.addTo(map.value);
                activeLayers.push(layer);
            } else {
                console.log("addLayer - we have no map")
            }
        }

        function removeLayer(layer) {
            if (map.value) {
                map.value.removeLayer(layer);
                const idx = activeLayers.indexOf(layer);
                if (idx > -1) {
                    activeLayers.splice(idx, 1);
                }
            }
        }

        function fitBounds(tl, br) {
            console.log(`fitBounds: ${JSON.stringify(tl)} , ${JSON.stringify(br)}`)
            if (map.value) {
                map.value.fitBounds([tl, br])
            }
        }

        function fitMapToContent() {
            console.log(`Global fitMapToContent. Active layers: ${activeLayers.length}`);
            if (!map.value || activeLayers.length === 0) return;

            // Robust bounds calculation
            /* eslint-disable no-undef */
            const bounds = L.latLngBounds();
            let foundObj = false;

            activeLayers.forEach(layerGroup => {
                // Handle FeatureGroup/LayerGroup recursion
                if (typeof layerGroup.eachLayer === 'function') {
                    layerGroup.eachLayer(layer => {
                        try {
                            if (typeof layer.getBounds === 'function') {
                                bounds.extend(layer.getBounds());
                                foundObj = true;
                            } else if (typeof layer.getLatLng === 'function') {
                                bounds.extend(layer.getLatLng());
                                foundObj = true;
                            }
                        } catch (e) { /* ignore */ }
                    });
                } else {
                    // It might be a single layer itself
                    try {
                        if (typeof layerGroup.getBounds === 'function') {
                            bounds.extend(layerGroup.getBounds());
                            foundObj = true;
                        } else if (typeof layerGroup.getLatLng === 'function') {
                            bounds.extend(layerGroup.getLatLng());
                            foundObj = true;
                        }
                    } catch (e) { /* ignore */ }
                }
            });
            /* eslint-enable no-undef */

            console.log(`Global Fit Bounds valid: ${bounds.isValid()}`);
            if (foundObj && bounds.isValid()) {
                map.value.fitBounds(bounds, { padding: [50, 50] });
            }
        }

        async function makeTestData(uid, timestart, timeend) {
            try {
                const token = localStorage.getItem('jwtToken');

                let filter = {
                    dbname: config.dbname,
                    uid: uid,
                    timestart: timestart,
                    timeend: timeend
                }

                const response = await axios.post(`${API_BASE_URL}/pidevents`, filter, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });

                sortEventList(response.data)

                let events = [];
                let lastGuid = "UNSET";
                for (let evt of response.data) {
                    console.log(`evt:${JSON.stringify(evt)}`)
                    if (evt.event === "newjourney") {
                        lastGuid = evt.guid
                        events.push(evt);
                    }
                    if (evt.event === "pos") {
                        evt.lastGuid = lastGuid
                        events.push(evt);
                    }
                }
                return events;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            }

        }

        async function makeEventLogs(uid, timestart, timeend) {
            try {
                const token = localStorage.getItem('jwtToken');

                let filter = {
                    dbname: config.dbname,
                    uid: uid,
                    timestart: timestart,
                    timeend: timeend
                }

                const response = await axios.post(`${API_BASE_URL}/pidevents`, filter, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });
                sortEventList(response.data)

                return response.data;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            }
        }


        async function makeTestDataForGuid(uid, guid) {
            try {
                const token = localStorage.getItem('jwtToken');

                let filter = {
                    dbname: config.dbname,
                    uid: uid,
                    guid: guid
                }

                const response = await axios.post(`${API_BASE_URL}/pidevents`, filter, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });
                sortEventList(response.data)

                let events = [];
                let lastGuid = "UNSET";
                for (let evt of response.data) {
                    console.log(`evt:${JSON.stringify(evt)}`)
                    if (evt.event === "newjourney") {
                        lastGuid = evt.guid
                        events.push(evt);
                    }
                    if (evt.event === "pos") {
                        evt.lastGuid = lastGuid
                        events.push(evt);
                    }
                }
                return events;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            }

        }

        async function makeEventLogsForGuid(uid, guid) {
            try {
                const token = localStorage.getItem('jwtToken');

                let filter = {
                    dbname: config.dbname,
                    uid: uid,
                    guid: guid
                }

                const response = await axios.post(`${API_BASE_URL}/pidevents`, filter, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });
                sortEventList(response.data)

                return response.data;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            }
        }

        // --------------------------------

        return {
            fetchPidEventsDayCounts,
            fetchPidEvents,
            eventColours,
            pideventcounts,
            pidevents,
            selectedeventcounts,
            selectedRow,
            map,
            setMap,
            addLayer,
            removeLayer,
            fitBounds,
            pidnewjourneyevents,
            pidjourneyevents,
            pidjourneyeventcounts,
            makeTestData,
            makeEventLogs,
            makeTestDataForGuid,
            makeTestDataForGuid,
            makeEventLogsForGuid,
            isLoading,
            isEventsLoading,
            map,
            setMap,
            addLayer,
            removeLayer,
            fitMapToContent,
            activeLayers,
            timeFilters
        };
    })();

}
